    $(document).ready(function(){
      $('.product_carousel').slick({
        slidesToShow: 4,
        dots:false,
        slidesToScroll: 4,
        arrows: true
      });
      
      $(".indiv-product").hover(function(){
        $(this).find(".quick-view-button").addClass('display');
      }, function(){
        $(this).find(".quick-view-button").removeClass('display');
      });
      
    });